import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, map } from 'rxjs';

import { cost_ddl, custom_field_type, custom_field_usage, paymenttermsReposeModel } from '../../organization/models/client-type';
import { costTypeResponseModel, suppliersReposeModel, taxOnInvoiceQuoteReposeModel, taxOnPoReposeModel } from '../../organization/models/costs';
import { apiEndpoints } from 'src/app/shared/enums/api-endpoints';
import { tasktaxModel } from '../../organization/models/task';
import { currencyResponseModel, DdataModel, dropdownReposeModel, emailTemplateTypeResponseModel, rolesResponseModel, timeZoneReposeModel } from '../../organization/models/organization';
import { DateFormatResponseModel } from '../../organization/models/staff';
import { EmailtemplateInsertVariablesModel, insertvariablesModel } from '../models/emailtemplate';
import { dueCriteriaReposeModel } from '../models/job-settings';

@Injectable({
  providedIn: 'root'
})
export class ddlService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getSupplier(page: number, limit: number): Observable<suppliersReposeModel> {
    return this.httpClient.get<suppliersReposeModel>(apiEndpoints.supplier_ddl + `?page=${page}&limit=${limit}`).pipe(
      map((response: suppliersReposeModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getTaxOnInvoiceQuote(page: number, limit: number): Observable<taxOnInvoiceQuoteReposeModel> {
    return this.httpClient.get<taxOnInvoiceQuoteReposeModel>(apiEndpoints.tax_on_quotes_invoice_ddl + `/?page=${page}&limit=${limit}`).pipe(
      map((response: taxOnInvoiceQuoteReposeModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getTaxOnPurchaseOrder(page: number, limit: number): Observable<taxOnPoReposeModel> {
    return this.httpClient.get<taxOnPoReposeModel>(apiEndpoints.tax_on_purchase_order_ddl + `/?page=${page}&limit=${limit}`).pipe(
      map((response: taxOnPoReposeModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getpayment_terms_ddl(page: number, limit: number): Observable<paymenttermsReposeModel> {
    return this.httpClient.get<paymenttermsReposeModel>(apiEndpoints.payment_terms_ddl + `/?page=${page}&limit=${limit}`).pipe(
      map((response: paymenttermsReposeModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getCostDdl(page: number, limit: number): Observable<cost_ddl> {
    return this.httpClient.get<cost_ddl>(apiEndpoints.cost_ddl + `?page=${page}&limit=${limit}`).pipe(
      map((response: cost_ddl) =>
        response
      ),
      catchError((error: cost_ddl) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getcustom_field_typeDdl(pagination:any): Observable<custom_field_type>{
    return this.httpClient.get<custom_field_type>(apiEndpoints.custom_field_type + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: custom_field_type) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getcustom_field_usageDdl(pagination:any): Observable<custom_field_usage>{
    return this.httpClient.get<custom_field_usage>(apiEndpoints.custom_field_usage + `?page=${pagination.page}&limit=${pagination.limit}`).pipe(
      map((response: custom_field_usage) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getTaskTax(page: number, limit: number): Observable<tasktaxModel> {
    return this.httpClient.get<tasktaxModel>(apiEndpoints.tax_ddl + `?page=${page}&limit=${limit}`).pipe(
      map((response: tasktaxModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  timeZoneddl(page: number, limit: number): Observable<timeZoneReposeModel> {
    return this.httpClient.get<timeZoneReposeModel>(apiEndpoints.time_zone + `?page=${page}&limit=${limit}`).pipe(
      map((response: timeZoneReposeModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getDateFormatDdl(): Observable<DateFormatResponseModel> {
    return this.httpClient.get<DateFormatResponseModel>(apiEndpoints.organizer_console_ddl).pipe(
      map((response: DateFormatResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getCurrencyDdl(page: number, limit: number): Observable<currencyResponseModel> {
    return this.httpClient.get<currencyResponseModel>(apiEndpoints.currency_ddl  + `?page=${page}&limit=${limit}`).pipe(
      map((response:currencyResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getRolesDdl(page: number, limit: number, is_default: number): Observable<rolesResponseModel> {
    return this.httpClient.get<rolesResponseModel>(apiEndpoints.roles_ddl  + `?page=${page}&limit=${limit}&is_default=${is_default}`).pipe(
      map((response:rolesResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getDecimalDdl(page: number, limit: number): Observable<dropdownReposeModel> {
    return this.httpClient.get<dropdownReposeModel>(apiEndpoints.round_unit_price  + `?page=${page}&limit=${limit}`).pipe(
      map((response:dropdownReposeModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getEmailTemplateType(page: number, limit: number): Observable<emailTemplateTypeResponseModel> {
    return this.httpClient.get<emailTemplateTypeResponseModel>(apiEndpoints.email_template_type + `?page=${page}&limit=${limit}`).pipe(
      map((response:emailTemplateTypeResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getInsertVariables(template_type_id: number): Observable<EmailtemplateInsertVariablesModel> {
    return this.httpClient.get<EmailtemplateInsertVariablesModel>(apiEndpoints.template_type_variable + `?template_type_id=${template_type_id}` ).pipe(
      map((response:EmailtemplateInsertVariablesModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    ); 
  }

  getCostType(): Observable<costTypeResponseModel> {
    return this.httpClient.get<costTypeResponseModel>(apiEndpoints.cost_sell_type).pipe(
      map((response: costTypeResponseModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getDuecriteria(page: number, limit: number): Observable<dueCriteriaReposeModel> {
    return this.httpClient.get<dueCriteriaReposeModel>(apiEndpoints.due_creteria + `?page=${page}&limit=${limit}`).pipe(
      map((response: dueCriteriaReposeModel) =>
        response
      ),
      catchError((error: HttpErrorResponse) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }

  getJobtemplatePhaseDDl(page: number,limit: number,job_template_id:any): Observable<any> {
    return this.httpClient.get<any>(apiEndpoints.job_template_phase_ddl + `?job_template_id=${job_template_id}&page=${page}&limit=${limit}`).pipe(
      map((response: any) =>
        response
      ),
      catchError((error: any) => {
        throw new Error('Something went wrong. Please try again later.');
      })
    );
  }
}
